const AUTH_CALLBACK_BLOCKLIST = new Set([
	"/auth/continue",
	"/auth/login",
	"/login",
	"/onboarding",
]);

export function getFirstSearchParamValue(
	value?: string | string[] | null,
): string | null {
	if (Array.isArray(value)) {
		return value[0] ?? null;
	}

	return value ?? null;
}

export function normalizeCallbackUrl(
	callbackUrl?: string | null,
): string | null {
	const trimmed = callbackUrl?.trim();

	if (
		!trimmed ||
		!trimmed.startsWith("/") ||
		trimmed.startsWith("//") ||
		trimmed.includes("\\")
	) {
		return null;
	}

	const hashIndex = trimmed.indexOf("#");
	const beforeHash = hashIndex === -1 ? trimmed : trimmed.slice(0, hashIndex);
	const hash = hashIndex === -1 ? "" : trimmed.slice(hashIndex);
	const queryIndex = beforeHash.indexOf("?");
	const pathname =
		queryIndex === -1 ? beforeHash : beforeHash.slice(0, queryIndex);
	const search = queryIndex === -1 ? "" : beforeHash.slice(queryIndex);

	if (!pathname.startsWith("/")) {
		return null;
	}

	if (AUTH_CALLBACK_BLOCKLIST.has(pathname)) {
		return null;
	}

	return `${pathname}${search}${hash}`;
}

export function buildAuthLoginPath(callbackUrl?: string | null) {
	const safeCallbackUrl = normalizeCallbackUrl(callbackUrl);

	if (!safeCallbackUrl) {
		return "/auth/login";
	}

	return `/auth/login?callbackUrl=${encodeURIComponent(safeCallbackUrl)}`;
}

export function buildAuthContinuePath(callbackUrl?: string | null) {
	const safeCallbackUrl = normalizeCallbackUrl(callbackUrl);

	if (!safeCallbackUrl) {
		return "/auth/continue";
	}

	return `/auth/continue?callbackUrl=${encodeURIComponent(safeCallbackUrl)}`;
}

export function buildOnboardingPath(callbackUrl?: string | null) {
	const safeCallbackUrl = normalizeCallbackUrl(callbackUrl);

	if (!safeCallbackUrl) {
		return "/onboarding";
	}

	return `/onboarding?callbackUrl=${encodeURIComponent(safeCallbackUrl)}`;
}

export function resolvePostAuthDestination(
	callbackUrl: string | null | undefined,
	onboardingCompleted: boolean,
) {
	if (onboardingCompleted) {
		return normalizeCallbackUrl(callbackUrl) ?? "/dashboard";
	}

	return buildOnboardingPath(callbackUrl);
}

export function resolvePostOnboardingDestination(callbackUrl?: string | null) {
	return normalizeCallbackUrl(callbackUrl) ?? "/dashboard";
}
